import { Component, OnInit, EventEmitter, Output, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { Router } from "@angular/router";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { FilePickerService } from "../../shared/file-picker/file-picker.service";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AboutComponent } from "src/app/pages/about/about.component";
import { ChangePasswordComponent } from "src/app/pages/change-password/change-password.component";
import { LoginService } from "src/app/account/login/login.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-topbar",
  templateUrl: "./topbar.component.html",
  styleUrls: ["./topbar.component.scss"],
})
export class TopbarComponent implements OnInit {
  element: any;
  first_name: any;
  last_name: any;
  role: any;
  profileImageHandler: any;
  isReadonly: boolean = false;
  safeSrc: SafeResourceUrl | undefined;
  environment: any = environment;
  @Output() mobileMenuButtonClicked = new EventEmitter();

  userData: any;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    private sanitizer: DomSanitizer,
    private filePickerService: FilePickerService,
    private modalService: NgbModal,
    private loginService: LoginService
  ) {}

  ngOnInit(): void {
    let that = this;
    let user = JSON.parse(localStorage.getItem('currentUser') || '{}');
    that.isReadonly = user ? user.isReadonly: false;
    that.first_name = user.user.FirstName ? user.user.FirstName : "UNAPP";
    that.last_name = user.user.LastName ? user.user.LastName : "User";
    that.profileImageHandler = (user && user.ProfileImageAttachmentFileHandle) ? (user.ProfileImageAttachmentFileHandle ? user.ProfileImageAttachmentFileHandle : '') : '';    
    that.safeSrc = that.profileImageHandler ? that.sanitizer.bypassSecurityTrustResourceUrl(that.filePickerService.generateLink(that.profileImageHandler)!) : 'assets/images/users/user-icon.png';
    this.element = document.documentElement;
  }

  openAboutModal() {
    this.modalService.open(AboutComponent, { centered: true });
  }

  openChangePassModal() {
    this.modalService.open(ChangePasswordComponent, {
       centered: true,
       backdrop: 'static',
       keyboard: false
       });
  }

  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  fullscreen() {
    document.body.classList.toggle("fullscreen-enable");
    if (
      !document.fullscreenElement &&
      !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement
    ) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  logout() {
    this.loginService.logout();
  }

  windowScroll() {
    if (
      document.body.scrollTop > 100 ||
      document.documentElement.scrollTop > 100
    ) {
      document.getElementById("back-to-top")?.classList.remove("d-none");
    } else {
      document.getElementById("back-to-top")?.classList.add("d-none");
    }
  }
}
